import { $myFetch } from "."
import { Roles } from "../../utils"

export const $getComFamilies = (role: Roles) => {
  const myHeaders = new Headers()
  return $myFetch("commercialtree", {
    headers: myHeaders
  }, [], role)
}
